<template>
    <VJoyIcon v-if="joyIconName" :name="joyIconName" color="neutral" size="small" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';

    const props = defineProps<{
        icon?: string;
    }>();

    const iconMap: Record<string, JoyIconsId> = {
        Fee: 'fee',
        File: 'file',
        'File check': 'file-check',
        Key: 'key',
        'Legal check': 'legal-check',
        Lock: 'lock',
        Security: 'security',
        'Users check': 'user-check',
        'Logo Axa': 'axa-logo',
    };

    const joyIconName = computed(() => (props.icon ? iconMap[props.icon] : undefined));
</script>
